import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Fetchexecutequery, Fetchfileupload } from "../../../services/process/BRS1/brsService7";

function FileUploadScreen() {

  const [source, setSource] = useState("");
  const [month, setMonth] = useState("");
  const [file, setFile] = useState(null);
  const [division, setDivision] = useState(null);
  const [department, setDepartment] = useState(null);

  const [divisionOptions, setDivisionOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const [loading, setLoading] = useState(false);


  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [error, setError] = useState(null);

const fieldBox = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  padding: "8px",
  background: "white",
  borderRadius: "6px",
  border: "1px solid #e0e0e0",
  minWidth: "180px",
};

const labelStyle = {
  fontSize: "15px",
  fontWeight: "600",
  color: "#333",
  marginBottom: "2px",
};

const containerStyle = {
  display: "flex",
  gap: "15px",
  alignItems: "flex-end",
  background: "#f5f6fa",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

const customSelectStyles = {
  container: (base) => ({
    ...base,
    width: "220px",
  }),

  control: (base, state) => ({
    ...base,
    backgroundColor: "#dddfe5",
    borderColor: state.isFocused ? "#aaa" : "#ccc",
    borderRadius: "5px",
    minHeight: "42px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    "&:hover": {
      borderColor: "#aaa",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    padding: "10px",
  }),

  singleValue: (base) => ({
    ...base,
    color: "black",
  }),

  placeholder: (base) => ({
    ...base,
    color: "#555",
  }),

  menu: (base) => ({
    ...base,
    backgroundColor: "#dddfe5",
    borderRadius: "5px",
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#c7cad1"
      : state.isFocused
      ? "#d1d4db"
      : "#dddfe5",
    color: "black",
    cursor: "pointer",
  }),

  indicatorSeparator: () => ({ display: "none" }),
};

  const gridRef = useRef();

  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
useEffect(() => {
  const fetchEntities = async () => {
    try {
      const data = await runQuery(`
        SELECT division_id, name 
        FROM user_management.divisions
        WHERE is_active = 1 and entity_id = 8;
      `);

      const formatted = data.map((row) => ({
        value: row.division_id,
        label: row.name,
      }));

      setDivisionOptions(formatted);
    } catch (e) {
      setError("Failed to load divisions");
    }
  };

  fetchEntities();
}, []);

useEffect(() => {
  if (!division) {
    setDepartmentOptions([]);
    setDepartment(null);
    return;
  }

  const fetchDepartments = async () => {
    try {
      const data = await runQuery(`
        SELECT department_id, name 
        FROM user_management.department
        WHERE division_id = ${division.value};
      `);

      const formatted = data.map((row) => ({
        value: row.department_id,
        label: row.name,
      }));

      setDepartmentOptions(formatted);
    } catch (e) {
      setError("Failed to load departments");
    }
  };

  fetchDepartments();
}, [division]);

  const sourceOptions = [
    { value: "jv", label: "JV",skiprow:0 },
    { value: "salary_register", label: "Salary Register",skiprow:3 },
  ];

  // ==========================
  // HELPERS
  // ==========================
  const getFormattedDate = () => {
    const d = new Date();
    return d.toISOString().slice(0, 19).replace("T", " ");
  };

  async function runQuery(query) {
    const payload = { query };
    const [creds, url] = Fetchexecutequery();
    const res = await axios.post(url, payload, creds);
    return res.data;
  }

  const formatColumnName = (name) =>
    name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  // ==========================
  // FETCH HISTORY
  // ==========================
  const fetchUploadHistory = async () => {
    const payload = {
      query: `
        SELECT 
          file_uploads_id,
          file_name,
          file_size,
          status,
          comments,
          DATE_FORMAT(uploaded_time, '%d-%m-%Y %H:%i:%s') AS created_on
        FROM process_data.file_uploads
        WHERE is_active = 1
          AND entities_id = ${userCredentials.selectedentity}
        ORDER BY file_uploads_id DESC
        LIMIT 50;
      `,
    };

    try {
      const creds = Fetchexecutequery();
      const res = await axios.post(creds[1], payload, creds[0]);

      if (res.data.length > 0) {
        const cols = Object.keys(res.data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
        }));

        setColumnDefs(cols);
        setRowData(res.data);
      }
    } catch (err) {
      setError("Error fetching upload history");
    }
  };

  // ==========================
  // UPLOAD HANDLER
  // ==========================

const uploadFileToServer = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("filePath", `/home/demo/${source}/`);

  try {
    const response = await axios.post(
      "http://154.61.75.209:1200/api/v2/user_modules/upload/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log("Upload Progress:", percent + "%");
        },
      }
    );

    return {
      fileName: response.data.Filename,
      filePath: response.data.Filepath,
    };
  } catch (err) {
    console.error("Upload error:", err);
    throw new Error("File upload failed");
  }
};
const handleUpload = async () => {
  if (!division || !department || !source || !month || !file) {
    alert("Please fill all fields");
    return;
  }

  try {
    const uploadedFile = await uploadFileToServer(file);

    const payload = {
      file_name: uploadedFile.fileName,
      file_path: uploadedFile.filePath,
      source_name: source,
      config_id: 20,
      month: month,
      table: source,
      skiprows: source === "salary_register" ? 3 : 0,
      tenants_id: userCredentials.tenants_id,
      groups_id: userCredentials.groups_id,
      entities_id: userCredentials.selectedentity,
      division_id: division.value,
      department_id: department.value,
      user_id: userCredentials.user_id,
      source_type: source,
      process_id: 36,
    };

    const creds = Fetchfileupload();
    await axios.post(creds[1], payload, creds[0]);

    alert("Upload successful");

    // ✅ RESET ALL FIELDS
    setDivision(null);
    setDepartment(null);
    setSource("");
    setMonth("");
    setFile(null);

    fetchUploadHistory();

  } catch (err) {
    alert("Upload failed");
  }
};

  useEffect(() => {
    fetchUploadHistory();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ color: "#4969ab" }}>File Upload & History</h3>

      {error && <div style={{ color: "red" }}>{error}</div>}

      {/* ==========================
          FORM
      ========================== */}
<div style={{ display: "flex", justifyContent: "center", marginBottom: "30px" }}>
  <div style={containerStyle}>

    {/* DIVISION */}
    <div style={fieldBox}>
      <label style={labelStyle}>Division</label>
      <Select
        placeholder="Select Division"
        value={division}
        options={divisionOptions}
        onChange={(selected) => {
          setDivision(selected);
          setDepartment(null);
        }}
        styles={customSelectStyles}
      />
    </div>

    {/* DEPARTMENT */}
    <div style={fieldBox}>
      <label style={labelStyle}>Department</label>
      <Select
        placeholder="Select Department"
        value={department}
        options={departmentOptions}
        isDisabled={!division}
        onChange={(selected) => setDepartment(selected)}
        styles={customSelectStyles}
      />
    </div>

    {/* SOURCE */}
    <div style={fieldBox}>
      <label style={labelStyle}>Source</label>
      <Select
        placeholder="Select Source"
        value={sourceOptions.find(opt => opt.value === source) || null}
        options={sourceOptions}
        onChange={(selected) =>
          setSource(selected?.value || "")
        }
        styles={customSelectStyles}
      />
    </div>
    
    {/* MONTH */}
    <div style={fieldBox}>
      <label style={labelStyle}>Month</label>
      <input
        type="month"
        value={month}
        onChange={(e) => setMonth(e.target.value)}
      />

    </div>

    {/* FILE */}
    <div style={fieldBox}>
      <label style={labelStyle}>Upload File</label>
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={(e) => setFile(e.target.files[0])}
      />
    </div>

    {/* BUTTON */}
    <div style={{ ...fieldBox, justifyContent: "flex-end" }}>
      <button
        onClick={handleUpload}
        style={{
          height: "42px",
          background: "#000055",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "500",
        }}
      >
        Upload
      </button>
    </div>

  </div>
</div>

      <div
        className="ag-theme-alpine"
        style={{ height: "500px", width: "100%" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          paginationPageSize={10}
        />
      </div>
    </div>
  );
}

export default FileUploadScreen;